define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../domain"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, domain_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PublicReport = void 0;
    class PublicReport extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "RefId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Lga", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Name", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "NameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ContactDetails", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ContactDetailsError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ReportDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ReportDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Description", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DescriptionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemState", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemStateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Shape", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, PublicReport.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.RefId = b.RefId;
            a.Lga = b.Lga;
            a.LgaCode = b.LgaCode;
            a.Name = b.Name;
            a.ContactDetails = b.ContactDetails;
            a.ReportDate = b.ReportDate;
            a.Description = b.Description;
            a.SystemState = (0, EntityUtil_1.toInt)(entity.SystemState);
            a.AuditCreateUser = b.AuditCreateUser;
            a.AuditCreateDate = b.AuditCreateDate;
            a.AuditEditUser = b.AuditEditUser;
            a.AuditEditDate = b.AuditEditDate;
            a.Shape = (0, EntityUtil_1.mergePoint)(a.Shape, b.Shape);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, PublicReport.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqString(validationState, "LgaCode", "LGA Code");
                this.validateReqString(validationState, "Name", "Name");
                this.validateReqString(validationState, "ContactDetails", "Contact Details");
                this.validateReqDate(validationState, "ReportDate", "Report Date");
                this.validateReqString(validationState, "Description", "Description");
                this.validateReqNumber(validationState, "SystemState", "System State");
                this.validateReqString(validationState, "AuditCreateUser", "AUDIT_CREATE_USER");
                this.validateReqDate(validationState, "AuditCreateDate", "AUDIT_CREATE_DATE");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                RefId: this.RefId,
                Lga: this.Lga,
                LgaCode: this.LgaCode,
                Name: this.Name,
                ContactDetails: this.ContactDetails,
                ReportDate: this.ReportDate,
                Description: this.Description,
                SystemState: this.SystemState,
                AuditCreateUser: this.AuditCreateUser,
                AuditCreateDate: this.AuditCreateDate,
                AuditEditUser: this.AuditEditUser,
                AuditEditDate: this.AuditEditDate,
                Shape: this.Shape.toJSON(),
                IsGeometryModified: this.IsGeometryModified,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get IsUserPriviledgedToEdit() {
            return this.SecurityAccessLevel == EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        get IsReadOnly() {
            return !this.IsUserPriviledgedToEdit || this.SystemState == domain_1.EntitySysStatusDomain.Archived;
        }
        get IsActive() {
            return this.SystemState == domain_1.EntitySysStatusDomain.Active;
        }
    }
    exports.PublicReport = PublicReport;
    Object.defineProperty(PublicReport, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "PublicReport"
    });
    Object.defineProperty(PublicReport, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Public Report"
    });
    Object.defineProperty(PublicReport, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "RefId", "Lga", "LgaCode", "Name", "ContactDetails", "ReportDate", "Description", "SystemState", "AuditCreateUser", "AuditCreateDate", "AuditEditUser", "AuditEditDate", "Shape"]
    });
    Object.defineProperty(PublicReport, "RefIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(PublicReport, "RefIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PublicReport, "LgaLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(PublicReport, "LgaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PublicReport, "LgaCodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(PublicReport, "LgaCodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PublicReport, "NameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 50
    });
    Object.defineProperty(PublicReport, "NameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PublicReport, "ContactDetailsLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(PublicReport, "ContactDetailsTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter some contact details for the person that reported the incident"
    });
    Object.defineProperty(PublicReport, "ContactDetailsReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PublicReport, "ReportDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PublicReport, "DescriptionLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(PublicReport, "DescriptionTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter a free-text description of the incident that is being reported"
    });
    Object.defineProperty(PublicReport, "DescriptionReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PublicReport, "SystemStateDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PublicReport, "SystemStateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PublicReport, "AuditCreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(PublicReport, "AuditCreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PublicReport, "AuditCreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PublicReport, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(PublicReport, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PublicReport, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "RefId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "RefIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "Lga", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "LgaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "LgaCode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "LgaCodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "Name", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "NameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "ContactDetails", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "ContactDetailsError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "ReportDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "ReportDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "Description", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "DescriptionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "SystemState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "SystemStateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "AuditCreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "AuditCreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "AuditCreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "AuditCreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PublicReport.prototype, "Shape", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], PublicReport.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], PublicReport.prototype, "IsUserPriviledgedToEdit", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], PublicReport.prototype, "IsReadOnly", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], PublicReport.prototype, "IsActive", null);
});
